import React, { useCallback, useState } from "react";
import { Banner, Container, Footer, Header, LabelBox, Price, RadioBox, Title, WithoutImage, Wrapper } from "./styles";
import { Description } from "../styles";
import { formattedPrice } from "../../../utils";
import ModalDescription from "../ModalDescription";
import { useDispatch } from "react-redux";
import { setProductForCheckout } from "../../../store/modules/billingPlan/actions";
import { Product } from "../../../utils/constants";

const PlanCard = ({ data, onChange }) => {
	const dispatch = useDispatch();

	const [openModal, setOpenModal] = useState(false);

	function handleModal() {
		setOpenModal(!openModal);
	}

	const { title, description, descriptionPros, price, banner, id, dataComplete } = data;

	const select = useCallback(
		(param) => {
			const find = dataComplete.find((item) => item.id_plan === param);
			onChange(find.title);
			dispatch(setProductForCheckout(find, Product.PLAN));
		},
		[dataComplete, dispatch, onChange]
	);

	return (
		<Container>
			<Header onClick={handleModal}>
				{banner ? <Banner src={banner} alt="logo plano" /> : <WithoutImage />}
				<Title>{title}</Title>
				<Description>{description}</Description>
			</Header>
			<Footer>
				<Wrapper>
					<RadioBox
						id={id}
						type="radio"
						name="select"
						onChange={() => select(id)}
						className="checkbox-style"
					/>
					<LabelBox htmlFor={id}>Selecionar</LabelBox>
				</Wrapper>
				<Price>{formattedPrice(price)}/mês</Price>
			</Footer>
			{openModal && (
				<ModalDescription
					show={openModal}
					handleClose={handleModal}
					description={description}
					descriptionPros={descriptionPros}
					title={title}
				/>
			)}
		</Container>
	);
};

export default PlanCard;
